function btnShowVisibility() {
  let navCoords = $('.listing-nav')[0]?.getBoundingClientRect();
  let btnShowCoords = $('.btn-show.visible')[0]?.getBoundingClientRect();
  let firstCardCoords = $('.card')[0]?.getBoundingClientRect();
  let middleScreen = document.body.clientHeight / 2;

  if (firstCardCoords?.y < middleScreen && navCoords?.y > btnShowCoords.y) {
    if (!$('.btns-show').hasClass('visible')) {
      $('.btns-show').addClass('visible');
    }
  } else {
    $('.btns-show').removeClass('visible');
  }
}

global.modules.set({
  async init(context) {
    let openedMap = false;

    $('.btn-show', context).each(function () {
      this.addEventListener('click', () => {
        switch (this.dataset.show) {
          case 'map':
            $('.map-block', context).addClass('active');
            $(this).removeClass('visible');
            $('.btn-show[data-show="result"]', context).addClass('visible')
            openedMap = true;
            break;

          case 'result':
            $('.map-block', context).removeClass('active');
            $(this).removeClass('visible');
            $('.btn-show[data-show="map"]', context).addClass('visible')
            openedMap = false;
            break;
        }
      });
    });

    btnShowVisibility()
  }
})

window.addEventListener('scroll', () => {
  btnShowVisibility()
})